module.exports = __webpack_public_path__ + "img/beforeAfter.7375f11a.png";